import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import dayjs from 'dayjs'

import { BarLoader, Icon } from '@st-operations/uikit/src/v2'

import Pagination from './Pagination'

const PAGE_SIZE = 10

const formatDate = (date) => dayjs(date).format('YYYY-MM-DD')

const getPages = (count) => {
  return new Array(Math.ceil(count / PAGE_SIZE)).fill(null).map((_, index) => index + 1)
}

const SeedsTable = ({
  query,
  createdBy,
  selectedSeed,
  setSelectedSeed,
  setReloadCollapsible,
  removeSeed,
  getSeeds,
}) => {
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(true)
      getSeeds({ query, email: createdBy, skip: (page - 1) * PAGE_SIZE }).then((resp) => {
        setData(resp.items)
        setCount(resp.count)
        setPage(getPages(resp.count).includes(page) ? page : getPages(resp.count)[0])
        setLoading(false)
      })
    }, 250)

    return () => clearTimeout(timeout)
  }, [query, createdBy, page])

  useEffect(() => {
    !loading && setReloadCollapsible(Math.random())
  }, [loading])

  const handleSelectSeed = (seed) => () => {
    if (selectedSeed?._id === seed._id) {
      removeSeed()
    } else {
      removeSeed()
      setSelectedSeed(seed)
    }
  }

  return (
    <>
      <Choose>
        <When condition={loading}>
          <div className="ac-seeds-block__table-loading">
            <BarLoader />
          </div>
        </When>
        <When condition={!loading && !data.length}>
          <div className="ac-seeds-block__table-empty">No seeds found</div>
        </When>
        <Otherwise>
          <div className="ac-seeds-block__table">
            <div className="ac-seeds-block__table-row ac-seeds-block__table-row--header">
              <span></span>
              <span>Name</span>
              <span>Created At</span>
              <span>Created By</span>
              <span>Updated At</span>
              <span>Updated By</span>
            </div>
            <For each="seed" of={data}>
              <button
                key={seed._id}
                className={classNames('ac-seeds-block__table-row', {
                  'ac-seeds-block__table-row--selected': selectedSeed?._id === seed._id,
                })}
                onClick={handleSelectSeed(seed)}
              >
                <span
                  className={classNames('ac-seeds-block__radio-button', {
                    'ac-seeds-block__radio-button--selected': selectedSeed?._id === seed._id,
                  })}
                >
                  <Icon icon="checkmark" type="fill" color="#fff" />
                </span>
                <span>{seed.name}</span>
                <span>{formatDate(seed.createdAt)}</span>
                <span>{seed.createdBy.email}</span>
                <span>{formatDate(seed.updatedAt)}</span>
                <span>{seed.updatedBy.email}</span>
              </button>
            </For>
          </div>
          <Pagination pages={getPages(count)} page={page} setPage={setPage} />
        </Otherwise>
      </Choose>
    </>
  )
}

export default SeedsTable
